import isError from 'error.iserror';
import { configure } from 'safe-stable-stringify';
import { sendMessage } from "./message-sender";

const stringify = configure({
    bigint: true,
    circularValue: '[Circular]',
    deterministic: false,
    strict: false,
});

function setupErrorHandler() {
    window.addEventListener('error', function(e) {
        report({
            type: e.type,
            message: e.message,
            filename: e.filename,
            lineno: e.lineno,
            colno: e.colno,
            error: e.error,
            timeStamp: e.timeStamp,
        });
    });

    window.addEventListener('unhandledrejection', function(e) {
        report({
            type: e.type,
            reason: e.reason,
            timeStamp: e.timeStamp,
        });
    });
}

function report(obj) {
    if (isError(obj)) {
        reportError(obj);
    } else {
        reportErrorMessage(stringify2(obj));
    }
}

function stringify2(obj) {
    const space = 4;
    return stringify(obj, (key, val) => {
        if (isError(val)) {
            return {
                name: val.name,
                stack: val.stack,
                cause: val.cause,
                columnNumber: val.columnNumber,
                fileName: val.fileName,
                lineNumber: val.lineNumber,
                message: val.message,
            };
        }
        if (val instanceof Map) {
            return {
                type: "Map",
                value: Array.from(val.entries()),
            };
        }
        if (val instanceof Set) {
            return {
                type: "Set",
                value: Array.from(val),
            };
        }
        if (val instanceof Date) {
            return {
                type: "Date",
                value: val.toISOString(),
            };
        }
        if (val instanceof RegExp) {
            return {
                type: "RegExp",
                value: val.toString(),
            };
        }
        return val;
    }, space);
}

function reportError(error) {
    var str = error.toString();
    var stack = error.stack || '';
    var errorMessage;
    if (stack.startsWith(str)) {
        errorMessage = stack;
    } else {
        errorMessage = str + '\n' + stack;
    }
    reportErrorMessage(errorMessage);
}

function reportErrorMessage(errorMessage) {
    sendMessage({
        DRF: {
            subject: 'report-error',
            errorMessage,
        },
    });
}

export {
    setupErrorHandler,
};